export const SET_POINT = "SET_POINT";

export const POINTS_GET_HISTORY_REQUEST = "POINTS_GET_HISTORY_REQUEST";
export const POINTS_GET_HISTORY_SUCCESS = "POINTS_GET_HISTORY_SUCCESS";
export const POINTS_GET_HISTORY_ERROR = "POINTS_GET_HISTORY_ERROR";
